import { IView } from "../Core/View";
import { ViewFactory } from "../Core/Factories/ViewFactory";

import { RegisterView } from "./TrainingGroup/RegisterView";
import { TimeTableView } from "./TrainingGroup/TimeTableView";

ViewFactory.setRegistry({
    'RegisterView': RegisterView,
    'TimeTableView': TimeTableView
});


// WEBPACK FOOTER //
// ./www/js/Pages/TrainingGroup.ts